.textField {
  width: 100%;
  :global(.MuiOutlinedInput-root) {
    align-items: center;
    border-radius: 0.25rem;
    min-height: 2.625rem;
  }

  /* MUI adds 14px padding-right when an end adornment is present — reclaim that space. */
  :global(.MuiOutlinedInput-root:not(.MuiAutocomplete-inputRoot)) {
    padding-right: 0;
  }

  :global(.MuiOutlinedInput-notchedOutline) {
    border-color: var(--pm-grey10);
  }

  :global(.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline) {
    border-color: var(--pm-blue-strong);
  }

  :global(.Mui-focused .MuiOutlinedInput-notchedOutline) {
    border-color: var(--pm-blue-strong);
  }

  :global(.MuiOutlinedInput-root.Mui-disabled) {
    background: var(--pm-grey13);

    :global(.MuiOutlinedInput-notchedOutline) {
      border-color: var(--pm-grey10) !important;
    }

    &:hover :global(.MuiOutlinedInput-notchedOutline) {
      border-color: var(--pm-grey10) !important;
    }
  }

  :global(
    .MuiOutlinedInput-root.Mui-disabled .MuiInputLabel-root.MuiInputLabel-shrink
  ) {
    background: var(--pm-grey13);
  }

  :global(.MuiInputLabel-root.MuiInputLabel-shrink) {
    background: var(--pm-white);
    padding: 0 0.1875rem;
    transform: translate(12px, -8px) scale(1);
    font-size: 0.719rem;
  }

  :global(.MuiAutocomplete-endAdornment .MuiSvgIcon-root),
  :global(.MuiInputAdornment-root .MuiIconButton-root),
  :global(.MuiSvgIcon-root) {
    color: var(--pm-grey8);
  }

  /* Input */
  :global(.MuiInputBase-root) {
    font-family: var(--pm-font-family) !important;
    /* Input - Hover */
    &:hover {
      :global(.MuiOutlinedInput-notchedOutline) {
        border-color: var(--pm-blue);
      }
    }
  }

  /* Outlined text inputs (not Autocomplete — padding lives on inputRoot there). */
  :global(
    .MuiOutlinedInput-root:not(.MuiAutocomplete-inputRoot) .MuiInputBase-input
  ) {
    padding: 9px 15px;
  }

  :global(.MuiInputBase-inputMultiline) {
    padding: 0.25rem 0 0;
  }

  /* Label */
  :global(.MuiFormLabel-root) {
    font-family: var(--pm-font-family) !important;
    transform: translate(12px, 10px) scale(1);
    font-size: 0.938rem;
    &:global(.Mui-focused) {
      color: var(--pm-grey5);
    }
  }
  /* Error */
  :global(.Mui-error) {
    font-family: var(--pm-font-family) !important;
    letter-spacing: 0;
  }
}

/* Select (MUI Autocomplete) — keep autocomplete padding separate from text/textarea fields. */
.selectField {
  :global(.MuiAutocomplete-inputRoot) {
    height: 2.625rem;
    padding: 0 1rem;
  }

  &.multiSelectField {
    :global(.MuiAutocomplete-inputRoot) {
      height: auto;
      min-height: 2.625rem;
    }
  }

  :global(
    .MuiOutlinedInput-root.MuiAutocomplete-inputRoot .MuiAutocomplete-input
  ) {
    min-width: 0;
    padding: 0 0 0 7px;
  }
}

.datePickerField {
  /* Beat MUI emotion padding-right on the adorned outlined input root. */
  :global(.MuiInputBase-root.MuiOutlinedInput-root) {
    padding-right: 0 !important;
  }

  :global(.MuiInputAdornment-root.MuiInputAdornment-positionEnd) {
    align-items: center;
    display: flex;
    flex-shrink: 0;
    height: 40px;
    justify-content: center;
    margin-left: 0;
    max-height: 40px;
    max-width: 40px;
    min-height: 40px;
    min-width: 40px;
    width: 40px;
  }

  :global(.MuiInputAdornment-root .MuiIconButton-root) {
    flex-shrink: 0;
    height: 40px;
    margin: 0;
    padding: 0;
    width: 40px;
  }

  /* MUI sets padding via shorthand (e.g. 16.5px 14px) — override fully, not just padding-right. */
  :global(.MuiInputBase-input.MuiInputBase-inputAdornedEnd) {
    padding: 0 0 0 15px !important;
  }
}

.autocompletePopperPaper {
  &:global(.MuiPaper-root) {
    background: var(--pm-white);
    border-radius: 14px !important;
    box-shadow: 0 36px 36px -14px rgb(20 20 20 / 25%) !important;
    box-sizing: border-box !important;
    font-family: var(--pm-font-family);
    overflow: hidden;
    padding: 4px !important;
  }
}

.autocompleteListbox {
  /* Portaled listbox: bind to MUI class so we beat global `.MuiAutocomplete-root .option-item`. */
  &:global(.MuiAutocomplete-listbox) {
    background: transparent;
    border-radius: 14px;
    box-sizing: border-box !important;
    font-family: var(--pm-font-family);
    padding: 0 !important;
    text-align: left;
  }

  :global(.MuiAutocomplete-groupLabel) {
    color: var(--pm-grey6);
    font-family: var(--pm-font-family);
    font-size: 0.6875rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1;
    padding: 0 0 0.625rem;
    text-transform: uppercase;
  }

  :global(.MuiAutocomplete-groupUl) {
    padding: 0;
  }

  :global(.MuiAutocomplete-option.option-item:not(.option-item-with-icon)),
  :global(.option-item:not(.option-item-with-icon)) {
    align-items: flex-start !important;
    background: transparent;
    border-radius: 0.75rem;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap !important;
    font-family: var(--pm-font-family);
    font-weight: 400 !important;
    gap: 0.125rem;
    justify-content: flex-start !important;
    margin: 0 0 2px;
    min-height: 0;
    padding: 0.5625rem 0.625rem !important;
    text-align: left !important;
  }

  /* Icon + title + description (e.g. Scenario select) — grid beats global flex-wrap rules. */
  :global(.MuiAutocomplete-option.option-item.option-item-with-icon),
  :global(.option-item.option-item-with-icon) {
    align-items: start !important;
    background: transparent;
    border-radius: 0.75rem;
    column-gap: 0.625rem;
    display: grid !important;
    flex-wrap: nowrap !important;
    font-family: var(--pm-font-family);
    grid-template-columns: 24px minmax(0, 1fr);
    margin: 0 0 2px;
    min-height: 0;
    padding: 0.5625rem 0.625rem !important;
    row-gap: 0.125rem;
    text-align: left !important;
  }

  :global(.MuiAutocomplete-option.Mui-focused),
  :global(.MuiAutocomplete-option[aria-selected="true"]),
  :global(.option-item.Mui-focused),
  :global(.option-item[aria-selected="true"]) {
    background: var(--pm-grey12) !important;
  }

  :global(.option-icon) {
    align-items: center;
    align-self: start;
    box-sizing: border-box;
    color: var(--pm-grey8);
    display: flex;
    flex: none;
    grid-column: 1;
    grid-row: 1 / span 2;
    height: 24px !important;
    justify-content: center;
    max-height: 24px;
    max-width: 24px;
    min-height: 24px;
    min-width: 24px;
    overflow: hidden;
    width: 24px !important;
  }

  :global(.option-icon svg) {
    display: block;
    flex: none;
    height: 24px !important;
    max-height: 24px !important;
    max-width: 24px !important;
    min-height: 24px;
    min-width: 24px;
    width: 24px !important;
  }

  :global(.option-label) {
    color: var(--pm-grey1);
    display: block;
    flex: none;
    font-family: var(--pm-font-family);
    font-size: 1rem;
    font-style: normal;
    font-weight: 400 !important;
    letter-spacing: -0.03rem;
    line-height: 1.25rem;
    text-align: left;
    white-space: normal;
    width: 100%;
  }

  :global(.option-item-with-icon .option-label),
  :global(.option-item-with-icon .option-secondary-label) {
    flex: none !important;
    grid-column: 2;
    margin-left: 0 !important;
    width: auto;
  }

  :global(.option-secondary-label) {
    color: var(--pm-grey6);
    display: block;
    flex: none;
    font-family: var(--pm-font-family);
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    letter-spacing: -0.02625rem;
    line-height: 1.25rem;
    margin-left: 0;
    text-align: left;
    white-space: normal;
    width: 100%;
  }
}

.mobileMenuScrim {
  display: none;
}

:global(.theme-dark1) {
  .autocompletePopperPaper {
    &:global(.MuiPaper-root) {
      background: var(--D4) !important;
      box-sizing: border-box !important;
      padding: 4px !important;
    }
  }

  .autocompleteListbox {
    &:global(.MuiAutocomplete-listbox) {
      background: transparent !important;
      padding: 0 !important;
    }

    :global(.MuiAutocomplete-groupLabel) {
      color: var(--pm-text-tertiary);
    }

    :global(.option-label) {
      color: var(--D12);
    }

    :global(.option-secondary-label) {
      color: var(--pm-text-tertiary);
    }

    :global(.option-icon) {
      color: var(--D9);
    }

    :global(.MuiAutocomplete-option:hover),
    :global(.MuiAutocomplete-option.Mui-focused),
    :global(.MuiAutocomplete-option[aria-selected="true"]),
    :global(.option-item:hover),
    :global(.option-item.Mui-focused),
    :global(.option-item[aria-selected="true"]) {
      background: var(--D5) !important;
    }
  }
}

/* Select dropdowns use `.option-item`; padding on paper (portaled popper may omit module classes). */
:global(.MuiAutocomplete-popper:has(.option-item)) {
  font-family: var(--pm-font-family);

  :global(.MuiAutocomplete-paper),
  :global(.MuiPaper-root:not(.pm-paper)) {
    box-sizing: border-box !important;
    font-family: var(--pm-font-family);
    padding: 4px !important;
  }

  :global(.MuiAutocomplete-listbox) {
    background: transparent !important;
    box-sizing: border-box !important;
    font-family: var(--pm-font-family);
    padding: 0 !important;
  }

  :global(.MuiAutocomplete-option),
  :global(.option-item),
  :global(.option-label),
  :global(.option-secondary-label),
  :global(.MuiAutocomplete-groupLabel) {
    font-family: var(--pm-font-family);
  }
}

:global(.theme-dark1 .MuiAutocomplete-popper:has(.option-item)) {
  :global(.MuiAutocomplete-paper),
  :global(.MuiPaper-root:not(.pm-paper)) {
    background: var(--D4) !important;
  }
}

:global(.theme-dark1),
:global(.dark) {
  .textField :global(.MuiOutlinedInput-notchedOutline) {
    border-color: var(--D7, #3f3f46);
  }

  .textField
    :global(.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline),
  .textField :global(.Mui-focused .MuiOutlinedInput-notchedOutline) {
    border-color: var(--pm-blue-lighter);
  }

  .textField :global(.MuiInputLabel-root.MuiInputLabel-shrink) {
    background: var(--pm-dark-text-field-label-background, var(--D3, #1e1e22));
  }

  .textField :global(.MuiInputBase-input.Mui-disabled) {
    -webkit-text-fill-color: var(--D12) !important;
    color: var(--D12) !important;
  }
}

@media screen and (max-width: 600px) {
  .mobileMenuScrim {
    background: transparent;
    border: 0;
    display: block;
    inset: 0;
    padding: 0;
    position: fixed;
    z-index: 1300;
  }

  .mobileMenuPopper {
    z-index: 1301;

    :global(.MuiAutocomplete-paper) {
      max-height: 33.333vh !important;
    }

    :global(.MuiAutocomplete-listbox) {
      max-height: calc(33.333vh - 0.5rem) !important;
    }
  }
}
